import { AlertCircle } from 'lucide-react';
import { motion } from 'motion/react';
import {
  Alert,
  AlertCloseButton,
  AlertDescription,
  AlertTitle
} from 'v5/design-system/Alert';

/**
 * A unit's failed action over or under its content. Eases in and out when
 * it is the child of an `AnimatePresence`.
 */
export function UnitErrorAlert({
  title,
  message,
  onClose
}: {
  title: string;
  message: string;
  onClose(): void;
}) {
  return (
    <motion.div
      initial={{ opacity: 0, height: 0, overflow: 'hidden' }}
      animate={{ opacity: 1, height: 'auto', overflow: 'visible' }}
      exit={{ opacity: 0, height: 0, overflow: 'hidden' }}
      transition={{ duration: 0.2 }}
      className="my-2"
    >
      <Alert variant="destructive" data-element="server-error">
        <AlertCircle />
        <AlertTitle className="text-base">{title}</AlertTitle>
        <AlertDescription>
          {message}
          <AlertCloseButton onClick={onClose} />
        </AlertDescription>
      </Alert>
    </motion.div>
  );
}
